import React from "react";
const ContextMenuIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 16C13.329 16 14 16.672 14 17.5C14 18.328 13.329 19 12.5 19C11.671 19 11 18.328 11 17.5C11 16.672 11.671 16 12.5 16ZM12.5 10C13.329 10 14 10.672 14 11.5C14 12.328 13.329 13 12.5 13C11.671 13 11 12.328 11 11.5C11 10.672 11.671 10 12.5 10ZM12.5 4C13.329 4 14 4.672 14 5.5C14 6.328 13.329 7 12.5 7C11.671 7 11 6.328 11 5.5C11 4.672 11.671 4 12.5 4Z",
      fill: "currentColor"
    }
  )
);
var ContextMenuIcon_default = ContextMenuIcon;
export {
  ContextMenuIcon_default as default
};
//# sourceMappingURL=ContextMenuIcon.js.map
